import React from 'react'
import type { DateType } from '@ztechapps/common.utils'
import { useUserTimeZone } from '@ztechapps/common.hook'
import { formatConstants, formatDate } from '@ztechapps/common.utils'

// Not `LocalDateTime`: its emptiness check reads a `Date` as empty and prints "--", and the thread's
// optimistic message carries a `Date` timestamp until the server's copy replaces it.
export const MessageTimeStamp = ({ value }: { value?: DateType }) => {
  const timeZone = useUserTimeZone()

  return <small>{formatDate(value ?? undefined, formatConstants.dateTime, timeZone)}</small>
}
